/**
 * Gets a random number from 0 (inclusive) to arraySize (not inclusive)
 * @param {number} arrSize - the upper bound
 */
export const getRandomIndex = (arrSize: number) => {
    return Math.floor(Math.random() * arrSize);
};
